<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-briefcase"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'contador.dashboard.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'contador.dashboard.subtitulo' | translate }}</p>
  </div>
</div>

<div class="page-body">

  <!-- =================================================================== -->
  <!-- Situacao carregando                                                 -->
  <!-- =================================================================== -->
  <div *ngIf="carregandoSituacao" class="form-card">
    <div class="card-content">
      <div class="estado-inline">
        <i class="pi pi-spinner pi-spin"></i>
        <span>{{ 'contador.dashboard.estados.carregando' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- =================================================================== -->
  <!-- Erro ao carregar situacao                                           -->
  <!-- =================================================================== -->
  <div *ngIf="!carregandoSituacao && erroSituacao" class="form-card">
    <div class="card-content">
      <div class="estado-vazio">
        <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
        <p>{{ 'contador.dashboard.estados.erro_situacao' | translate }}</p>
        <button pButton
          [label]="'contador.dashboard.estados.tentar_novamente' | translate"
          icon="pi pi-refresh"
          class="btn-primary btn-sm"
          (click)="carregarSituacao()">
        </button>
      </div>
    </div>
  </div>

  <!-- =================================================================== -->
  <!-- Branch NAO-contador: painel de solicitar                            -->
  <!-- =================================================================== -->
  <div *ngIf="!carregandoSituacao && !erroSituacao && !situacao?.contador" class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi pi-user-plus"></i>
      </div>
      <span class="card-header-title">{{ 'contador.solicitar.titulo' | translate }}</span>
    </div>

    <div class="card-content">
      <app-solicitar-contador-panel
        [embutido]="true"
        (solicitado)="onSolicitado()">
      </app-solicitar-contador-panel>
    </div>
  </div>

  <!-- =================================================================== -->
  <!-- Branch CONTADOR: dashboard                                          -->
  <!-- =================================================================== -->
  <ng-container *ngIf="!carregandoSituacao && !erroSituacao && situacao?.contador">

  <p-tabView styleClass="tabs-underline" (onChange)="onTabChange($any($event))">

    <!-- =============== Aba 1: Meus contratos =============== -->
    <p-tabPanel [header]="'contador.dashboard.abas.meus_contratos' | translate">

    <!-- Card: Tabela de contratos (com resumo de totais no topo) -->
    <div class="table-card">
      <div class="card-header">
        <div class="card-header-icon table-icon">
          <i class="pi pi-file-edit"></i>
        </div>
        <span class="card-header-title">{{ 'contador.dashboard.tabela.titulo' | translate }}</span>
        <!-- Filtros compactos (Estado + periodo de vencimento) + Exportar (PDF),
             a direita do header. Mesmo padrao da aba "Gastos acessorios". -->
        <div class="contratos-header-acoes">
          <p-dropdown
            class="filtro-compacto filtro-estado"
            [options]="contratosStatusOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="contratosStatus"
            (onChange)="onContratosFiltroChange()"
            [pTooltip]="'contador.dashboard.contratos.filtro_estado' | translate"
            tooltipPosition="top"
            appendTo="body"
            styleClass="w-full">
          </p-dropdown>
          <app-periodo-filtro
            class="filtro-compacto filtro-periodo"
            modo="avancado"
            [persistir]="false"
            [valorPadrao]="'showAll'"
            styleClass="w-full"
            [pTooltip]="'contador.dashboard.contratos.filtro_periodo' | translate"
            tooltipPosition="top"
            (periodoChanged)="onContratosPeriodoChanged($event)">
          </app-periodo-filtro>
          <!-- Botoes de acao agrupados (Exportar + Novo contrato) DENTRO de
               .contratos-header-acoes: o wrapper ancora o PAR a direita como uma
               unidade na responsividade (com um unico margin-left:auto), evitando
               que um dos botoes quebre para outra linha e fique orfao. Altura
               padronizada (44px) pelo grupo (sem .btn-sm). -->
          <div class="acoes-botoes">
            <!-- Exportar: menu popup (PDF / Excel / CSV) dos contratos com os filtros
                 atuais da aba. Espelha a aba "Gastos acessorios". Os itens sao
                 remontados na abertura (idioma atual) via abrirMenuExportarContratos. -->
            <button pButton
              type="button"
              icon="pi pi-file-export"
              class="p-button-outlined p-button-secondary"
              style="gap: 0.35rem"
              [label]="'contador.dashboard.contratos.exportar.botao' | translate"
              [pTooltip]="'contador.dashboard.contratos.exportar.tooltip' | translate"
              tooltipPosition="top"
              [attr.aria-label]="'contador.dashboard.contratos.exportar.tooltip' | translate"
              [disabled]="exportandoContratos"
              [loading]="exportandoContratos"
              (click)="abrirMenuExportarContratos($event, menuExportarContratos)">
            </button>
            <p-menu #menuExportarContratos [popup]="true" [model]="exportarContratosItens" appendTo="body"></p-menu>
            <button pButton type="button"
              [label]="'contador.dashboard.novo_contrato.botao' | translate"
              icon="pi pi-plus"
              class="btn-primary"
              (click)="abrirNovoContrato()">
            </button>
          </div>
        </div>
      </div>

      <div class="card-content">
        <!-- Resumo de totais (movido do card "Resumo": tiles no topo do card) -->
        <!-- Loading -->
        <div *ngIf="carregandoResumo" class="estado-inline">
          <i class="pi pi-spinner pi-spin"></i>
          <span>{{ 'contador.dashboard.resumo.carregando' | translate }}</span>
        </div>

        <!-- Erro -->
        <div *ngIf="!carregandoResumo && erroResumo" class="estado-vazio">
          <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
          <p>{{ 'contador.dashboard.resumo.erro_carregar' | translate }}</p>
          <button pButton
            [label]="'contador.dashboard.estados.tentar_novamente' | translate"
            icon="pi pi-refresh"
            class="btn-primary btn-sm"
            (click)="carregarResumo()">
          </button>
        </div>

        <!-- Dados -->
        <div *ngIf="!carregandoResumo && !erroResumo && resumo" class="resumo-grid">
          <div class="resumo-item">
            <span class="resumo-valor">{{ resumo.totalClientes }}</span>
            <span class="resumo-rotulo">{{ 'contador.dashboard.resumo.total_clientes' | translate }}</span>
            <span class="resumo-ranking" *ngIf="ranking">
              <i class="pi pi-trophy"></i>
              {{ 'contador.dashboard.ranking.posicao' | translate: { posicao: ranking.posicaoPorClientesComContratoAtivo, total: ranking.totalContadores } }}
            </span>
          </div>
          <div class="resumo-item">
            <span class="resumo-valor">{{ resumo.clientesAtivos }}</span>
            <span class="resumo-rotulo">{{ 'contador.dashboard.resumo.clientes_ativos' | translate }}</span>
            <span class="resumo-ranking" *ngIf="ranking">
              <i class="pi pi-trophy"></i>
              {{ 'contador.dashboard.ranking.posicao' | translate: { posicao: ranking.posicaoPorIndicacoesAtivas, total: ranking.totalContadores } }}
            </span>
          </div>
          <div class="resumo-item">
            <span class="resumo-valor">{{ resumo.valorTotalContratosAtivos | guaraniFormat }}</span>
            <span class="resumo-rotulo">{{ 'contador.dashboard.resumo.valor_contratos_ativos' | translate }}</span>
            <span class="resumo-ranking" *ngIf="ranking">
              <i class="pi pi-trophy"></i>
              {{ 'contador.dashboard.ranking.posicao' | translate: { posicao: ranking.posicaoPorValorContratosAtivos, total: ranking.totalContadores } }}
            </span>
          </div>
          <div class="resumo-item">
            <span class="resumo-valor">{{ resumo.aReceberDespesasAcessorias | guaraniFormat }}</span>
            <span class="resumo-rotulo">{{ 'contador.dashboard.resumo.a_receber_despesas' | translate }}</span>
          </div>
        </div>

        <!-- Faixa de erro acima da tabela -->
        <div *ngIf="erroContratos" class="estado-inline estado-erro">
          <span>{{ 'contador.dashboard.tabela.erro_carregar' | translate }}</span>
          <button pButton
            [label]="'contador.dashboard.estados.tentar_novamente' | translate"
            icon="pi pi-refresh"
            class="p-button-text btn-sm"
            (click)="recarregarContratos()">
          </button>
        </div>

        <p-table [value]="contratos"
          [lazy]="true"
          (onLazyLoad)="onLazyLoadContratos($event)"
          [rows]="rows"
          [first]="first"
          [totalRecords]="totalRecords"
          [loading]="carregandoContratos"
          [tableStyle]="{ width: '100%' }">

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 24%">{{ 'contador.dashboard.tabela.cliente' | translate }}</th>
              <th style="width: 13%" pSortableColumn="status">
                {{ 'contador.dashboard.tabela.estado' | translate }}<p-sortIcon [field]="'status'"></p-sortIcon>
              </th>
              <th style="width: 15%" pSortableColumn="valorMensal">
                {{ 'contador.dashboard.tabela.valor_mensal' | translate }}<p-sortIcon [field]="'valorMensal'"></p-sortIcon>
              </th>
              <th style="width: 14%" pSortableColumn="dataVencimento">
                {{ 'contador.dashboard.tabela.vencimento' | translate }}<p-sortIcon [field]="'dataVencimento'"></p-sortIcon>
              </th>
              <th style="width: 17%">
                {{ 'contador.dashboard.tabela.despesas_acessorias' | translate }}
                <i class="pi pi-info-circle info-coluna"
                   tabindex="0"
                   role="img"
                   [attr.aria-label]="'contador.dashboard.tabela.despesas_acessorias_info' | translate"
                   [pTooltip]="'contador.dashboard.tabela.despesas_acessorias_info' | translate"
                   tooltipPosition="top"></i>
              </th>
              <th style="width: 17%">
                {{ 'contador.dashboard.tabela.a_receber' | translate }}
                <i class="pi pi-info-circle info-coluna"
                   tabindex="0"
                   role="img"
                   [attr.aria-label]="'contador.dashboard.tabela.a_receber_info' | translate"
                   [pTooltip]="'contador.dashboard.tabela.a_receber_info' | translate"
                   tooltipPosition="top"></i>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-contrato>
            <tr class="linha-contrato-clicavel"
              tabindex="0"
              (click)="abrirOperarCliente(contrato)"
              (keydown.enter)="abrirOperarCliente(contrato)">
              <td>{{ contrato.nomeEmpresa || '-' }}</td>
              <td>
                <p-tag
                  [value]="labelStatus(contrato.status)"
                  [severity]="severityStatus(contrato.status)">
                </p-tag>
              </td>
              <td *ngIf="configMoedaContrato(contrato) as cfg">{{ contrato.valorMensal != null ? (contrato.valorMensal | moedaSimbolo: cfg.symbol : cfg.digits : cfg.locale) : '-' }}</td>
              <td>{{ contrato.dataVencimento ? (contrato.dataVencimento | date: 'dd/MM/yyyy') : '-' }}</td>
              <td>{{ contrato.totalDespesasAcessorias | guaraniFormat }}</td>
              <td>{{ contrato.aReceberDespesasAcessorias | guaraniFormat }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center p-5">
                <div class="flex flex-column align-items-center">
                  <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                  <div class="text-gray-500 text-lg">{{ 'contador.dashboard.tabela.vazio' | translate }}</div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="loadingbody">
            <tr>
              <td colspan="6" class="text-center p-5">
                <div class="flex justify-content-center align-items-center">
                  <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                  <span class="ml-3">{{ 'contador.dashboard.tabela.carregando' | translate }}</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Paginacao (mesmo modelo da Lista de Vendas / Operar Cliente):
             contagem a esquerda, "Itens por pagina" + dropdown a direita.
             Tabela lazy: a troca de pagina dispara onPageChange, que recarrega
             do backend. -->
        <div class="pagination-container">
          <div>
            <p-paginator
              (onPageChange)="onPageChange($any($event))"
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'contador.dashboard.tabela.contagem' | translate"
              [first]="first" [rows]="rows"
              [totalRecords]="totalRecords" [showFirstLastIcon]="true">
            </p-paginator>
          </div>
          <div class="flex align-items-center">
            <span class="mx-1 text-color">{{ 'contador.dashboard.tabela.itens_por_pagina' | translate }}</span>
            <!-- appendTo="body": o painel seria recortado pelo overflow do card;
                 renderizado no body fica imune (igual aos demais dropdowns). -->
            <p-dropdown [options]="pageSizeOptions" optionLabel="label"
              optionValue="value" [(ngModel)]="rows"
              (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem"
              appendTo="body">
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>

    </p-tabPanel>

    <!-- =============== Aba 2: Perto do vencimento =============== -->
    <p-tabPanel [header]="'contador.dashboard.abas.proximos_vencimento' | translate">

    <div class="table-card">
      <div class="card-header">
        <div class="card-header-icon table-icon">
          <i class="pi pi-calendar-clock"></i>
        </div>
        <span class="card-header-title">{{ 'contador.dashboard.proximos.titulo' | translate }}</span>
        <!-- Filtro de periodo de vencimento (compacto, a direita do header —
             mesmo padrao da aba Contrato de Operar Cliente). O rotulo vira
             tooltip; o proprio botao ja exibe o periodo selecionado. -->
        <div class="proximos-header-acoes">
          <app-periodo-filtro
            class="filtro-compacto"
            modo="avancado"
            [persistir]="false"
            [valorPadrao]="'showAll'"
            styleClass="w-full"
            [pTooltip]="'contador.dashboard.proximos.filtro_periodo' | translate"
            tooltipPosition="top"
            (periodoChanged)="onProximosPeriodoChanged($event)">
          </app-periodo-filtro>
        </div>
      </div>

      <div class="card-content">
        <!-- Barra de selecao + acao em lote -->
        <div class="lote-bar" *ngIf="proximosSelecionados.length > 0">
          <span class="lote-bar-info">
            {{ 'contador.dashboard.proximos.selecionados' | translate: { count: proximosSelecionados.length } }}
          </span>
          <button pButton
            type="button"
            icon="pi pi-bolt"
            class="btn-primary btn-sm"
            style="gap: 0.35rem"
            [label]="'contador.dashboard.proximos.gerar_lote_botao' | translate: { count: proximosSelecionados.length }"
            [disabled]="gerandoLote"
            (click)="abrirGerarLote()">
          </button>
        </div>

        <!-- Faixa de erro acima da tabela -->
        <div *ngIf="erroProximos" class="estado-inline estado-erro">
          <span>{{ 'contador.dashboard.proximos.erro_carregar' | translate }}</span>
          <button pButton
            [label]="'contador.dashboard.estados.tentar_novamente' | translate"
            icon="pi pi-refresh"
            class="p-button-text btn-sm"
            (click)="carregarProximos(0)">
          </button>
        </div>

        <p-table [value]="proximos"
          [lazy]="true"
          (onLazyLoad)="onProximosLazyLoad($event)"
          [rows]="proximosRows"
          [first]="proximosFirst"
          [totalRecords]="proximosTotalRecords"
          [loading]="carregandoProximos"
          dataKey="id"
          selectionMode="multiple"
          [metaKeySelection]="false"
          [(selection)]="proximosSelecionados"
          [tableStyle]="{ width: '100%' }">

          <ng-template pTemplate="header">
            <tr>
              <th class="col-selecao" style="width: 3.5rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th style="width: 26%">{{ 'contador.dashboard.tabela.cliente' | translate }}</th>
              <th style="width: 18%" pSortableColumn="valorMensal">
                {{ 'contador.dashboard.tabela.valor_mensal' | translate }}<p-sortIcon [field]="'valorMensal'"></p-sortIcon>
              </th>
              <th style="width: 16%" pSortableColumn="dataVencimento">
                {{ 'contador.dashboard.proximos.col_vencimento' | translate }}<p-sortIcon [field]="'dataVencimento'"></p-sortIcon>
              </th>
              <th style="width: 20%" pSortableColumn="mesReferencia">
                {{ 'contador.dashboard.proximos.col_mes_referencia' | translate }}<p-sortIcon [field]="'mesReferencia'"></p-sortIcon>
              </th>
              <th style="width: 15%" pSortableColumn="diaCobranca">
                {{ 'contador.dashboard.proximos.col_dia_cobranca' | translate }}<p-sortIcon [field]="'diaCobranca'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-contrato let-rowIndex="rowIndex">
            <tr [pSelectableRow]="contrato" [pSelectableRowIndex]="rowIndex">
              <!-- stopPropagation: sem isso o clique no checkbox alterna a selecao
                   pelo p-tableCheckbox E borbulha ate o pSelectableRow do <tr>,
                   gerando um duplo toggle que anula a selecao. -->
              <td class="col-selecao" (click)="$event.stopPropagation()">
                <p-tableCheckbox [value]="contrato"></p-tableCheckbox>
              </td>
              <td>{{ contrato.nomeEmpresa || '-' }}</td>
              <td *ngIf="configMoedaContrato(contrato) as cfg">{{ contrato.valorMensal != null ? (contrato.valorMensal | moedaSimbolo: cfg.symbol : cfg.digits : cfg.locale) : '-' }}</td>
              <td>{{ contrato.dataVencimento ? (contrato.dataVencimento | date: 'dd/MM/yyyy') : '-' }}</td>
              <td>{{ mesReferenciaLabel(contrato.mesReferencia) }}</td>
              <td>{{ contrato.diaCobranca || '-' }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center p-5">
                <div class="flex flex-column align-items-center">
                  <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                  <div class="text-gray-500 text-lg">{{ 'contador.dashboard.proximos.vazio' | translate }}</div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="loadingbody">
            <tr>
              <td colspan="6" class="text-center p-5">
                <div class="flex justify-content-center align-items-center">
                  <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                  <span class="ml-3">{{ 'contador.dashboard.tabela.carregando' | translate }}</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Paginacao (mesmo modelo da aba Meus contratos) -->
        <div class="pagination-container" *ngIf="proximosTotalRecords > 0">
          <div>
            <p-paginator
              (onPageChange)="onProximosPageChange($any($event))"
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'contador.dashboard.tabela.contagem' | translate"
              [first]="proximosFirst" [rows]="proximosRows"
              [totalRecords]="proximosTotalRecords" [showFirstLastIcon]="true">
            </p-paginator>
          </div>
          <div class="flex align-items-center">
            <span class="mx-1 text-color">{{ 'contador.dashboard.tabela.itens_por_pagina' | translate }}</span>
            <p-dropdown [options]="pageSizeOptions" optionLabel="label"
              optionValue="value" [(ngModel)]="proximosRows"
              (ngModelChange)="onProximosRowsPerPageChange()" styleClass="w-6rem"
              appendTo="body">
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>

    </p-tabPanel>

    <!-- =============== Aba: Gastos acessorios (consolidado) =============== -->
    <p-tabPanel [header]="'contador.dashboard.abas.despesas' | translate">

    <div class="table-card">
      <div class="card-header">
        <div class="card-header-icon table-icon">
          <i class="pi pi-wallet"></i>
        </div>
        <span class="card-header-title">{{ 'contador.dashboard.despesas.titulo' | translate }}</span>
        <!-- Filtros compactos (indicado + situacao + periodo) a direita do header. -->
        <div class="despesas-header-acoes">
          <p-dropdown
            class="filtro-compacto filtro-indicado"
            [options]="despesasIndicadoOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="despesasClienteEmpresaId"
            (onChange)="onDespesasFiltroChange()"
            [pTooltip]="'contador.dashboard.despesas.filtro_indicado' | translate"
            tooltipPosition="top"
            appendTo="body"
            styleClass="w-full">
          </p-dropdown>
          <p-dropdown
            class="filtro-compacto"
            [options]="despesasStatusOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="despesasStatus"
            (onChange)="onDespesasFiltroChange()"
            [pTooltip]="'contador.dashboard.despesas.filtro_situacao' | translate"
            tooltipPosition="top"
            appendTo="body"
            styleClass="w-full">
          </p-dropdown>
          <app-periodo-filtro
            class="filtro-compacto filtro-periodo"
            modo="avancado"
            [persistir]="false"
            [valorPadrao]="'showAll'"
            styleClass="w-full"
            [pTooltip]="'contador.dashboard.despesas.filtro_periodo' | translate"
            tooltipPosition="top"
            (periodoChanged)="onDespesasPeriodoChanged($event)">
          </app-periodo-filtro>
          <!-- Exportar: menu popup (PDF / Excel / CSV) dos gastos acessorios com os
               filtros atuais da aba. Espelha o padrao de "Repasse de Comissoes". Os
               itens sao remontados na abertura (idioma atual) via abrirMenuExportarDespesas.
               Sem .btn-sm: adota o sizing padrao do PrimeNG (mesma altura ~45px dos
               dropdowns/periodo ao lado, que tambem usam o sizing padrao). -->
          <button pButton
            type="button"
            icon="pi pi-file-export"
            class="p-button-outlined p-button-secondary"
            style="gap: 0.35rem"
            [label]="'contador.dashboard.despesas.exportar.botao' | translate"
            [pTooltip]="'contador.dashboard.despesas.exportar.tooltip' | translate"
            tooltipPosition="top"
            [attr.aria-label]="'contador.dashboard.despesas.exportar.tooltip' | translate"
            [disabled]="exportandoDespesas"
            [loading]="exportandoDespesas"
            (click)="abrirMenuExportarDespesas($event, menuExportarDespesas)">
          </button>
          <p-menu #menuExportarDespesas [popup]="true" [model]="exportarDespesasItens" appendTo="body"></p-menu>
        </div>
      </div>

      <div class="card-content">
        <!-- Faixa de erro acima da tabela -->
        <div *ngIf="erroDespesas" class="estado-inline estado-erro">
          <span>{{ 'contador.dashboard.despesas.erro_carregar' | translate }}</span>
          <button pButton
            [label]="'contador.dashboard.estados.tentar_novamente' | translate"
            icon="pi pi-refresh"
            class="p-button-text btn-sm"
            (click)="carregarDespesas(0)">
          </button>
        </div>

        <p-table [value]="despesas"
          [loading]="carregandoDespesas"
          [customSort]="true"
          (onSort)="onDespesasSort($event)"
          [sortField]="despesasSortField"
          [sortOrder]="despesasSortOrder"
          dataKey="id"
          [tableStyle]="{ width: '100%' }">

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 26%">{{ 'contador.dashboard.despesas.col_indicado' | translate }}</th>
              <th style="width: 16%" pSortableColumn="valor">
                {{ 'contador.dashboard.despesas.col_valor' | translate }}<p-sortIcon [field]="'valor'"></p-sortIcon>
              </th>
              <th style="width: 15%" pSortableColumn="dataPagamento">
                {{ 'contador.dashboard.despesas.col_data' | translate }}<p-sortIcon [field]="'dataPagamento'"></p-sortIcon>
              </th>
              <th style="width: 15%" pSortableColumn="tipoDespesa">
                {{ 'contador.dashboard.despesas.col_tipo' | translate }}<p-sortIcon [field]="'tipoDespesa'"></p-sortIcon>
              </th>
              <th style="width: 12%" pSortableColumn="status">
                {{ 'contador.dashboard.despesas.col_situacao' | translate }}<p-sortIcon [field]="'status'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-despesa>
            <!-- A linha abre os titulos do cliente em contas a receber. -->
            <tr [class.linha-clicavel]="temTitulosParaAbrir(despesa)"
                [attr.tabindex]="temTitulosParaAbrir(despesa) ? 0 : null"
                [pTooltip]="temTitulosParaAbrir(despesa)
                  ? ('contador.dashboard.despesas.abrir_titulos' | translate)
                  : ''"
                tooltipPosition="top"
                (click)="abrirTitulosDoCliente(despesa)"
                (keydown.enter)="abrirTitulosDoCliente(despesa)">
              <td>{{ despesa.nomeCliente || '-' }}</td>
              <td>{{ despesa.valor | guaraniFormat }}</td>
              <td>{{ despesa.dataPagamento | date: 'dd/MM/yyyy' }}</td>
              <td>{{ tipoDespesaNome(despesa.tipoDespesa) }}</td>
              <td>
                <p-tag [value]="statusDespesaLabel(despesa.status)"
                  [severity]="statusDespesaSeverity(despesa.status)">
                </p-tag>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center p-5">
                <div class="flex flex-column align-items-center">
                  <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                  <div class="text-gray-500 text-lg">{{ 'contador.dashboard.despesas.vazio' | translate }}</div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="loadingbody">
            <tr>
              <td colspan="6" class="text-center p-5">
                <div class="flex justify-content-center align-items-center">
                  <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                  <span class="ml-3">{{ 'contador.dashboard.tabela.carregando' | translate }}</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Paginacao (mesmo modelo das demais abas) -->
        <div class="pagination-container" *ngIf="despesasTotalRecords > 0">
          <div>
            <p-paginator
              (onPageChange)="onDespesasPageChange($any($event))"
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'contador.dashboard.tabela.contagem' | translate"
              [first]="despesasFirst" [rows]="despesasRows"
              [totalRecords]="despesasTotalRecords" [showFirstLastIcon]="true">
            </p-paginator>
          </div>
          <div class="flex align-items-center">
            <span class="mx-1 text-color">{{ 'contador.dashboard.tabela.itens_por_pagina' | translate }}</span>
            <p-dropdown [options]="pageSizeOptions" optionLabel="label"
              optionValue="value" [(ngModel)]="despesasRows"
              (ngModelChange)="onDespesasRowsPerPageChange()" styleClass="w-6rem"
              appendTo="body">
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>

    </p-tabPanel>

  </p-tabView>

  </ng-container>
</div>

<!-- =================================================================== -->
<!-- Dialog: Gerar parcelas em lote                                       -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="gerarLoteDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '34rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharGerarLote()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-bolt" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.dashboard.proximos.gerar_lote_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle">
          {{ 'contador.dashboard.proximos.gerar_lote_subtitulo' | translate: { count: proximosSelecionados.length } }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <div class="p-fluid formgrid grid gerar-lote-form inputnumber-stepper-compacto">
      <div class="field col-12 md:col-6">
        <label>{{ 'contador.dashboard.proximos.gerar_lote_quantidade' | translate }} <span class="required">*</span></label>
        <p-inputNumber
          [(ngModel)]="gerarLoteQuantidade"
          [min]="1"
          [showButtons]="true"
          [step]="1"
          [useGrouping]="false"
          styleClass="w-full"
          [class.error-field]="!!gerarLoteQuantidadeErro"
          (ngModelChange)="onGerarLoteQuantidadeChange()">
        </p-inputNumber>
        <small class="erro-validacao" *ngIf="gerarLoteQuantidadeErro">{{ gerarLoteQuantidadeErro }}</small>
      </div>

      <div class="field col-12 md:col-6">
        <label>{{ 'contador.dashboard.proximos.gerar_lote_primeiro_vencimento' | translate }}</label>
        <p-calendar
          [(ngModel)]="gerarLotePrimeiroVencimento"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [readonlyInput]="true"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
          [style]="{ width: '100%' }"
          [inputStyle]="{ width: '100%' }">
        </p-calendar>
        <small class="block mt-1 text-color-secondary">{{ 'contador.dashboard.proximos.gerar_lote_primeiro_vencimento_ajuda' | translate }}</small>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador.dashboard.novo_contrato.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="gerandoLote"
      (click)="fecharGerarLote()">
    </button>
    <button pButton
      [label]="'contador.dashboard.proximos.gerar_lote_confirmar' | translate"
      icon="pi pi-check"
      style="gap: 0.35rem"
      [disabled]="gerandoLote || !gerarLoteValido"
      [loading]="gerandoLote"
      (click)="confirmarGerarLote()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: confirmar volume alto (quantidade x contratos acima do teto) -->
<!-- A geracao nao tem desfazer: acima de gerarLoteTotalConfirmacao       -->
<!-- parcelas o usuario precisa confirmar explicitamente.                 -->
<!--                                                                      -->
<!-- ⚠️ NAO MOVA ESTE BLOCO. A POSICAO NO DOM E SIGNIFICATIVA: ele PRECISA -->
<!-- vir imediatamente DEPOIS do </p-dialog> de "Gerar parcelas em lote"  -->
<!-- (logo acima), porque os dois ficam abertos AO MESMO TEMPO.           -->
<!-- Motivo: src/styles.scss fixa `.p-dialog-mask { z-index: 1100         -->
<!-- !important }` e `.p-dialog { z-index: 1101 !important }`; como       -->
<!-- `!important` de folha de estilo vence o estilo inline, o             -->
<!-- auto-incremento de z-index do PrimeNG (ZIndexUtils.generateZIndex,   -->
<!-- +2 por modal) fica ANULADO e os dois dialogos empatam no mesmo       -->
<!-- z-index efetivo. Com empate, quem pinta por cima e quem vem DEPOIS   -->
<!-- no DOM.                                                              -->
<!-- Consequencia de mover/reagrupar (ex.: juntar os dialogos no fim do   -->
<!-- arquivo, ordenar alfabeticamente, extrair componente): esta          -->
<!-- confirmacao passa a renderizar ATRAS da mascara do dialogo de lote — -->
<!-- visivel, escurecida e INCLICAVEL. Quebra silenciosa: nao ha lint nem -->
<!-- teste que acuse. Tambem NAO adianta [baseZIndex] (perde para o       -->
<!-- !important) e mexer em styles.scss esta fora de escopo.              -->
<!-- Ver DESIGN_FE ui-gerar-parcelas-lote-contador §16.5 e §18.3.2.       -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="gerarLoteConfirmVolumeVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '34rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharGerarLoteVolume()">

  <div class="dialog-wave-header dialog-wave-header--warning">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.dashboard.proximos.gerar_lote_volume_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle">
          {{ 'contador.dashboard.proximos.gerar_lote_volume_subtitulo' | translate: { total: gerarLoteTotalParcelas, contratos: proximosSelecionados.length } }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>
      {{ 'contador.dashboard.proximos.gerar_lote_volume_mensagem' | translate: { total: gerarLoteTotalParcelas, contratos: proximosSelecionados.length } }}
    </p>
    <!-- Aviso de irreversibilidade em paragrafo PROPRIO e destacado (ambar,
         font-weight 600): a operacao nao tem desfazer e o publico e leigo.
         Diluir esta frase no paragrafo acima e perder o ponto. -->
    <p class="gerar-lote-volume-aviso">
      {{ 'contador.dashboard.proximos.gerar_lote_volume_sem_desfazer' | translate }}
    </p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button"
      [label]="'contador.dashboard.novo_contrato.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="gerandoLote"
      (click)="fecharGerarLoteVolume()">
    </button>
    <button pButton type="button"
      [label]="'contador.dashboard.proximos.gerar_lote_volume_confirmar' | translate"
      icon="pi pi-check"
      style="gap: 0.35rem"
      [disabled]="gerandoLote"
      [loading]="gerandoLote"
      (click)="confirmarGerarLoteVolume()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Novo contrato (solicitar)                                    -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="dialogNovoContrato"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end dialog-nuevo-contrato-scroll"
  [style]="{ width: '46rem' }"
  [breakpoints]="{ '960px': '80vw', '640px': '95vw' }"
  (onHide)="fecharNovoContrato()">

  <!-- Header com wave (padrao do sistema) -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-file-edit" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.dashboard.novo_contrato.titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle">{{ 'contador.dashboard.novo_contrato.subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <!-- Indicador das 3 etapas. Spans e traços controlados por `etapaNovoContrato`:
         nenhum módulo novo (p-steps/p-stepper não são usados em lugar nenhum do projeto).
         São sempre 3 passos — o checkbox "criar cadastro" engorda a etapa 1, não cria etapa.
         `aria-live` anuncia a troca; o título abaixo recebe o foco. -->
    <div class="etapas-indicador" aria-live="polite">
      <span class="etapas-indicador-passo" [class.etapas-indicador-passo--ativo]="etapaNovoContrato === 1"
        [class.etapas-indicador-passo--concluido]="etapaNovoContrato > 1">
        <i class="pi" [ngClass]="etapaNovoContrato > 1 ? 'pi-check-circle' : 'pi-user'"></i>
        {{ 'contador.dashboard.novo_contrato.etapa_cliente' | translate }}
      </span>
      <span class="etapas-indicador-traco" aria-hidden="true"></span>
      <span class="etapas-indicador-passo" [class.etapas-indicador-passo--ativo]="etapaNovoContrato === 2"
        [class.etapas-indicador-passo--concluido]="etapaNovoContrato > 2">
        <i class="pi" [ngClass]="etapaNovoContrato > 2 ? 'pi-check-circle' : 'pi-file-edit'"></i>
        {{ 'contador.dashboard.novo_contrato.etapa_contrato' | translate }}
      </span>
      <span class="etapas-indicador-traco" aria-hidden="true"></span>
      <span class="etapas-indicador-passo" [class.etapas-indicador-passo--ativo]="etapaNovoContrato === 3">
        <i class="pi pi-percentage"></i>
        {{ 'contador.dashboard.novo_contrato.etapa_cupom' | translate }}
      </span>
    </div>

    <!-- Alvo do foco na troca de etapa (tabindex -1: focável por código, fora da ordem do Tab). -->
    <h3 #tituloEtapaNovoContrato tabindex="-1" class="etapa-titulo">
      {{ chaveTituloEtapa | translate }}
    </h3>

    <div class="p-fluid formgrid grid">
    <!-- Resumo do cliente: vale para as etapas 2 e 3, então fica FORA delas. Quem é o
         cliente precisa continuar visível enquanto se definem valores e cupom. -->
    <div class="field col-12" *ngIf="etapaNovoContrato > 1 && resumoCliente">
      <div class="etapa-resumo-cliente">
        <i class="pi pi-user mr-2"></i>
        <span class="etapa-resumo-cliente-rotulo">
          {{ 'contador.dashboard.novo_contrato.resumo_cliente' | translate }}
        </span>
        <span class="etapa-resumo-cliente-valor">{{ resumoCliente }}</span>
        <span class="etapa-resumo-cliente-novo" *ngIf="novoContrato.criarConta">
          {{ 'contador.dashboard.novo_contrato.resumo_cliente_novo_cadastro' | translate }}
        </span>
      </div>
    </div>

    <!-- ================= ETAPA 1 — quem é o cliente ================= -->
    <ng-container *ngIf="etapaNovoContrato === 1">
    <!-- Cliente (indicado) -->
    <div class="field col-12">
      <label>
        {{ 'contador.dashboard.novo_contrato.cliente' | translate }}
        <i class="pi pi-info-circle ml-1 text-color-secondary" style="cursor: help; font-size: 0.9rem"
          [pTooltip]="'contador.dashboard.novo_contrato.cliente_ajuda' | translate"
          tooltipPosition="top"></i>
      </label>
      <p-dropdown
        [options]="clientesDisponiveis"
        optionLabel="nome"
        optionValue="configuracaoEmpresaId"
        [(ngModel)]="novoContrato.configuracaoEmpresaId"
        [filter]="true" filterBy="nome"
        [showClear]="true"
        [disabled]="!!(novoContrato.email && novoContrato.email.trim()) || novoContrato.criarConta"
        [placeholder]="'contador.dashboard.novo_contrato.cliente_placeholder' | translate"
        [emptyMessage]="'contador.dashboard.novo_contrato.sem_clientes' | translate"
        appendTo="body" styleClass="w-full">
      </p-dropdown>
    </div>

    <!-- OU por email (mesmo que nao esteja na lista de indicados) -->
    <div class="field col-12">
      <label>{{ 'contador.dashboard.novo_contrato.email' | translate }}</label>
      <!-- (blur) e o gatilho da AUTO-MARCACAO do "criar cadastro": so com o valor final.
           A busca em si continua reativa no (ngModelChange), alimentando o aviso abaixo. -->
      <input pInputText type="email"
        [ngModel]="novoContrato.email"
        (ngModelChange)="novoContrato.email = $event; onEmailContratoChange()"
        (blur)="onEmailContratoBlur()"
        [disabled]="!!novoContrato.configuracaoEmpresaId"
        [placeholder]="'contador.dashboard.novo_contrato.email_placeholder' | translate"
        class="w-full" />
      <!-- O formulario pode mudar sozinho depois desta checagem, entao ela precisa ser visivel. -->
      <small class="block mt-1 text-color-secondary" *ngIf="buscandoEmpresas">
        <i class="pi pi-spin pi-spinner mr-1"></i>
        {{ 'contador.dashboard.novo_contrato.email_verificando' | translate }}
      </small>
      <small class="block mt-1 text-color-secondary" *ngIf="!buscandoEmpresas">{{ 'contador.dashboard.novo_contrato.email_ajuda' | translate }}</small>
    </div>

    <!-- Criar conta do cliente (quando ainda não tem conta) -->
    <div class="field col-12">
      <div class="flex align-items-center gap-2">
        <p-checkbox [(ngModel)]="novoContrato.criarConta" [binary]="true" inputId="criarConta"
          (onChange)="onToggleCriarConta()"></p-checkbox>
        <label for="criarConta" class="m-0" style="cursor: pointer">
          {{ 'contador.dashboard.novo_contrato.criar_conta' | translate }}
        </label>
      </div>
    </div>

    <!-- Auto-marcação do "criar cadastro": o formulário acabou de mudar sozinho (8 campos novos
         apareceram), então precisa dizer POR QUE e como reverter. Sem botão, seguindo a
         convenção dos avisos abaixo: o texto orienta.
         A 2a linha existe porque desmarcar não é o mesmo que desistir — é escolher o CONVITE,
         que é um fluxo válido (o backend convida o cliente a criar a própria conta). -->
    <div class="field col-12" *ngIf="criarContaFoiAutoMarcado">
      <div class="p-2 border-round criar-conta-aviso criar-conta-aviso--info">
        <small class="block">
          <i class="pi pi-info-circle mr-1"></i>
          {{ 'contador.dashboard.novo_contrato.criar_conta_auto_marcado' | translate }}
        </small>
        <small class="block mt-1">
          {{ 'contador.dashboard.novo_contrato.criar_conta_auto_marcado_ajuda' | translate }}
        </small>
      </div>
    </div>

    <!-- A checagem falhou (rede/permissão): a tela NÃO sabe se o email tem conta, então não
         auto-marca nada e diz isso em vez de deixar o contador achar que "não tem conta". -->
    <div class="field col-12" *ngIf="erroBuscaEmail && !buscandoEmpresas">
      <div class="p-2 border-round criar-conta-aviso">
        <small class="block">
          <i class="pi pi-exclamation-triangle mr-1"></i>
          {{ 'contador.dashboard.novo_contrato.email_verificacao_falhou' | translate }}
        </small>
        <small class="block mt-1">
          {{ 'contador.dashboard.novo_contrato.email_verificacao_falhou_ajuda' | translate }}
        </small>
      </div>
    </div>

    <!-- Aviso de conta já existente para o email digitado (sem exibir dados de terceiros).
         Cada `situacao` devolvida pelo backend tem o seu proprio aviso. Nenhum tem BOTAO —
         quando ha algo a fazer, o texto orienta. JA_TEM_CONTRATO / PROPRIA_EMPRESA /
         DE_OUTRO_CONTADOR desabilitam "Criar contrato" nos dois modos (contaExistenteBloqueia,
         lido por novoContratoValido antes do ramo `criarConta`); DISPONIVEL segue permitido.

         Fica FORA do *ngIf do "criar cadastro" de proposito: a situacao da conta nao depende
         do checkbox.

         ⚠️ INVARIANTE dos textos: frase que menciona o CHECKBOX ou os CAMPOS DE CADASTRO so
         faz sentido no modo "criar cadastro" e precisa de `*ngIf="novoContrato.criarConta"` —
         fora dele instrui uma acao impossivel. Frase sobre CONTRATO ou EMAIL vale sempre. -->

    <div class="field col-12 flex flex-column gap-2" *ngIf="empresasEncontradas.length > 0">
      <ng-container *ngFor="let e of empresasEncontradas">
        <ng-container *ngIf="situacaoConta(e) as sit">
          <div class="p-2 border-round criar-conta-aviso"
            [class.criar-conta-aviso--bloqueio]="sit === 'JA_TEM_CONTRATO' || sit === 'PROPRIA_EMPRESA' || sit === 'DE_OUTRO_CONTADOR'"
            [ngSwitch]="sit">

              <!-- Conta existe e esta livre: informa e ORIENTA. O contrato sera vinculado a
                   conta existente de qualquer forma (o backend ignora `criarConta` e descarta
                   nome/telefone/RUC/atividade/cidade quando a conta ja existe). Deixar o
                   "criar cadastro" marcado so obriga o contador a preencher dados que nunca
                   serao usados — por isso a 2a linha pede o desmarque, em negrito por ser a
                   unica parte acionavel do aviso. Continua SEM bloquear "Criar contrato". -->
              <ng-container *ngSwitchCase="'DISPONIVEL'">
                <small class="block">
                  <i class="pi pi-exclamation-triangle mr-1"></i>
                  {{ 'contador.dashboard.novo_contrato.criar_conta_existe' | translate }}
                </small>
                <small class="block mt-1 font-bold" *ngIf="novoContrato.criarConta">
                  {{ 'contador.dashboard.novo_contrato.criar_conta_existe_ajuda' | translate }}
                </small>
                <small class="block mt-1 criar-conta-aviso-email">{{ e.email }}</small>
              </ng-container>

              <!-- Conta existe e o cliente JA e do contador: criar cadastro so duplicaria -->
              <ng-container *ngSwitchCase="'JA_TEM_CONTRATO'">
                <small class="block font-bold">
                  <i class="pi pi-ban mr-1"></i>
                  {{ 'contador.dashboard.novo_contrato.criar_conta_ja_e_cliente' | translate }}
                </small>
                <small class="block mt-1">
                  {{ 'contador.dashboard.novo_contrato.criar_conta_ja_e_cliente_ajuda' | translate }}
                </small>
                <small class="block mt-1 criar-conta-aviso-email">{{ e.email }}</small>
              </ng-container>

              <!-- O email digitado e o da propria empresa do contador -->
              <ng-container *ngSwitchCase="'PROPRIA_EMPRESA'">
                <small class="block font-bold">
                  <i class="pi pi-ban mr-1"></i>
                  {{ 'contador.dashboard.novo_contrato.criar_conta_propria_empresa' | translate }}
                </small>
                <small class="block mt-1">
                  {{ 'contador.dashboard.novo_contrato.criar_conta_propria_empresa_ajuda' | translate }}
                </small>
                <small class="block mt-1 criar-conta-aviso-email">{{ e.email }}</small>
              </ng-container>

              <!-- Email indisponivel: a empresa ja tem contrato com OUTRO contador. Bloqueia,
                   antecipando o 422 do POST. Nao revela quem e o outro contador. -->
              <ng-container *ngSwitchCase="'DE_OUTRO_CONTADOR'">
                <small class="block font-bold">
                  <i class="pi pi-ban mr-1"></i>
                  {{ 'contador.dashboard.novo_contrato.criar_conta_outro_contador' | translate }}
                </small>
                <small class="block mt-1">
                  {{ 'contador.dashboard.novo_contrato.criar_conta_outro_contador_ajuda' | translate }}
                </small>
                <small class="block mt-1 criar-conta-aviso-email">{{ e.email }}</small>
              </ng-container>

              <!-- Situacao ausente/desconhecida: avisa que a conta existe, sem bloquear -->
              <ng-container *ngSwitchDefault>
                <small class="block">
                  <i class="pi pi-exclamation-triangle mr-1"></i>
                  {{ 'contador.dashboard.novo_contrato.criar_conta_existe_generico' | translate }}
                </small>
                <small class="block mt-1" *ngIf="novoContrato.criarConta">
                  {{ 'contador.dashboard.novo_contrato.criar_conta_existe_generico_ajuda' | translate }}
                </small>
                <small class="block mt-1 criar-conta-aviso-email">{{ e.email }}</small>
              </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="novoContrato.criarConta">
      <div class="field col-12 md:col-6">
        <label>{{ 'contador.dashboard.novo_contrato.nombre_cliente' | translate }} <span class="required">*</span></label>
        <input pInputText [(ngModel)]="novoContrato.nomeCliente" class="w-full"
          [placeholder]="'contador.dashboard.novo_contrato.nombre_cliente_ph' | translate" />
      </div>
      <!-- Telefone: componente compartilhado com seletor de pais (bandeira + DDI) e mascara por pais.
           O label fica AQUI FORA, e nao no [label] interno do <app-phone-input>: o `gap: 6px` do
           `.field` so vale entre irmaos diretos, entao com o label dentro do componente o campo
           subia 8px em relacao ao "Nome do cliente" ao lado. -->
      <div class="field col-12 md:col-6 campo-telefone">
        <label>{{ 'contador.dashboard.novo_contrato.telefono' | translate }} <span class="required">*</span></label>
        <app-phone-input
          [(telefone)]="novoContrato.telefone"
          [(ddi)]="novoContrato.paisTelefone">
        </app-phone-input>
      </div>
      <div class="field col-12 md:col-6">
        <label>{{ 'contador.dashboard.novo_contrato.nombre_empresa' | translate }}</label>
        <input pInputText [(ngModel)]="novoContrato.nomeEmpresa" class="w-full" />
      </div>
      <!-- RUC: mesma mascara/placeholder do /signup (formato "NNNNNNN-D").
           Obrigatorio para criar a conta (o backend recusa com 422 sem ele). -->
      <div class="field col-12 md:col-6">
        <label>{{ 'contador.dashboard.novo_contrato.ruc' | translate }} <span class="required">*</span></label>
        <span class="p-input-icon-left w-full">
          <i class="pi pi-id-card"></i>
          <input pInputText
            [ngModel]="novoContrato.ruc"
            (input)="filtrarRucNovoContrato($event)"
            class="w-full"
            maxlength="20"
            inputmode="numeric"
            [placeholder]="'contador.dashboard.novo_contrato.ruc_ph' | translate" />
        </span>
      </div>

      <!-- Atividade da empresa: define grupos, subgrupos e marcas padrao da empresa nova.
           Mesma fonte do /signup (GET /enums/atividadeDaEmpresa); envia o NOME do enum. -->
      <div class="field col-12 md:col-6">
        <label>{{ 'contador.dashboard.novo_contrato.atividade' | translate }} <span class="required">*</span></label>
        <p-dropdown
          [options]="atividadesEmpresa"
          optionLabel="label" optionValue="value"
          [(ngModel)]="novoContrato.atividadeDaEmpresa"
          [filter]="true" filterBy="label"
          [showClear]="true"
          [disabled]="carregandoAtividades"
          [placeholder]="'contador.dashboard.novo_contrato.atividade_ph' | translate"
          appendTo="body" styleClass="w-full">
        </p-dropdown>
        <small *ngIf="carregandoAtividades" class="block mt-1 text-color-secondary">
          <i class="pi pi-spin pi-spinner mr-1"></i>
          {{ 'contador.dashboard.novo_contrato.atividade_carregando' | translate }}
        </small>
        <small *ngIf="erroAtividades && !carregandoAtividades" class="block mt-1 campo-erro">
          <i class="pi pi-exclamation-triangle mr-1"></i>
          {{ 'contador.dashboard.novo_contrato.atividade_erro' | translate }}
          <a class="link-retry" (click)="carregarAtividadesEmpresa()">
            {{ 'contador.dashboard.novo_contrato.tentar_novamente' | translate }}
          </a>
        </small>
      </div>

      <!-- Cidade: mesma fonte do /signup (GET /cidade?listarTodos=true); envia o id. -->
      <div class="field col-12 md:col-6">
        <label>{{ 'contador.dashboard.novo_contrato.cidade' | translate }} <span class="required">*</span></label>
        <p-dropdown
          [options]="cidades"
          optionLabel="label" optionValue="value"
          [(ngModel)]="novoContrato.cidadeId"
          [filter]="true" filterBy="label"
          [showClear]="true"
          [disabled]="carregandoCidades"
          [placeholder]="'contador.dashboard.novo_contrato.cidade_ph' | translate"
          appendTo="body" styleClass="w-full">
          <ng-template let-cidade pTemplate="item">
            <span>{{ cidade.label }}<span *ngIf="cidade.nomeEstado" class="text-color-secondary"> - {{ cidade.nomeEstado }}</span></span>
          </ng-template>
          <ng-template let-cidade pTemplate="selectedItem">
            <span *ngIf="cidade">{{ cidade.label }}<span *ngIf="cidade.nomeEstado"> - {{ cidade.nomeEstado }}</span></span>
          </ng-template>
        </p-dropdown>
        <small *ngIf="carregandoCidades" class="block mt-1 text-color-secondary">
          <i class="pi pi-spin pi-spinner mr-1"></i>
          {{ 'contador.dashboard.novo_contrato.cidade_carregando' | translate }}
        </small>
        <small *ngIf="erroCidades && !carregandoCidades" class="block mt-1 campo-erro">
          <i class="pi pi-exclamation-triangle mr-1"></i>
          {{ 'contador.dashboard.novo_contrato.cidade_erro' | translate }}
          <a class="link-retry" (click)="carregarCidades()">
            {{ 'contador.dashboard.novo_contrato.tentar_novamente' | translate }}
          </a>
        </small>
      </div>

      <!-- Moeda padrão da EMPRESA DO CLIENTE: mesma fonte e mesmo tooltip do /signup, para o
           contador ler o aviso que o cliente leria. NÃO é a moeda do CONTRATO (essa fica em
           "Valor mensal", sempre Guarani). -->
      <div class="field col-12 md:col-6">
        <label>
          {{ 'contador.dashboard.novo_contrato.moeda_empresa' | translate }} <span class="required">*</span>
          <i class="pi pi-info-circle ml-1 text-color-secondary" style="cursor: help; font-size: 0.9rem"
            [pTooltip]="'signup.labels.moeda_tooltip' | translate"
            tooltipPosition="top"></i>
        </label>
        <p-dropdown
          [options]="moedasEmpresa"
          optionLabel="label" optionValue="value"
          [(ngModel)]="novoContrato.moedaEmpresa"
          [placeholder]="'contador.dashboard.novo_contrato.moeda_placeholder' | translate"
          appendTo="body" styleClass="w-full">
        </p-dropdown>
      </div>

    </ng-container>

    </ng-container>
    <!-- ================= FIM DA ETAPA 1 ================= -->

    <!-- ================= ETAPA 2 — termos da cobrança ================= -->
    <ng-container *ngIf="etapaNovoContrato === 2">

    <!-- Valor mensal (sempre em GUARANI — prefixo (Gs) + nome da moeda no label;
         mascara/0 casas via configMoeda). -->
    <div class="field col-12 md:col-6">
      <label>
        {{ 'contador.dashboard.tabela.valor_mensal' | translate }}
        <span class="moeda-label">({{ moedaNomeChave | translate }})</span>
        <span class="required">*</span>
      </label>
      <p-inputNumber
        [(ngModel)]="novoContrato.valorMensal"
        [prefix]="prefixoMoeda"
        [currency]="configMoeda.symbol"
        [locale]="configMoeda.locale"
        [minFractionDigits]="casasDecimaisMoeda"
        [maxFractionDigits]="casasDecimaisMoeda"
        [useGrouping]="true"
        [monetaryMask]="casasDecimaisMoeda"
        [min]="0"
        [allowEmpty]="true"
        [placeholder]="'contador.dashboard.novo_contrato.valor_placeholder' | translate"
        styleClass="w-full" inputStyleClass="w-full">
      </p-inputNumber>
    </div>

    <!-- Dia de cobranca (dia do mes) -->
    <div class="field col-12 md:col-6">
      <label>{{ 'contador.dashboard.novo_contrato.dia_cobranca' | translate }} <span class="required">*</span></label>
      <p-dropdown
        [options]="diasCobrancaOptions"
        optionLabel="label" optionValue="value"
        [(ngModel)]="novoContrato.diaCobranca"
        [filter]="true"
        [placeholder]="'contador.dashboard.novo_contrato.dia_placeholder' | translate"
        appendTo="body" styleClass="w-full">
      </p-dropdown>
    </div>

    <!-- Vencimento do contrato -->
    <div class="field col-12 md:col-6">
      <label>{{ 'contador.dashboard.novo_contrato.data_vencimento' | translate }} <span class="required">*</span></label>
      <p-calendar
        [(ngModel)]="novoContrato.dataVencimento"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        [showButtonBar]="true"
        [placeholder]="'contador.dashboard.novo_contrato.data_placeholder' | translate"
        appendTo="body" styleClass="w-full">
      </p-calendar>
    </div>

    <!-- Mês de referência das parcelas (default: mês atual) -->
    <div class="field col-12 md:col-6">
      <label>
        {{ 'contador.dashboard.novo_contrato.mes_referencia' | translate }}
        <i class="pi pi-info-circle ml-1 text-color-secondary" style="cursor: help; font-size: 0.9rem"
          [pTooltip]="'contador.dashboard.novo_contrato.mes_referencia_ajuda' | translate"
          tooltipPosition="top"></i>
      </label>
      <p-dropdown
        [options]="mesReferenciaOptions"
        optionLabel="label" optionValue="value"
        [(ngModel)]="novoContrato.mesReferencia"
        appendTo="body" styleClass="w-full">
      </p-dropdown>
    </div>

    <!-- Parcelas por mês (quantas parcelas o aceite gera por mês de referência) -->
    <div class="field col-12 md:col-6">
      <label>
        {{ 'contador.dashboard.novo_contrato.parcelas_por_mes' | translate }}
        <i class="pi pi-info-circle ml-1 text-color-secondary" style="cursor: help; font-size: 0.9rem"
          [pTooltip]="'contador.dashboard.novo_contrato.parcelas_por_mes_ajuda' | translate"
          tooltipPosition="top"></i>
      </label>
      <p-inputNumber
        [(ngModel)]="novoContrato.parcelasPorMes"
        [min]="1" [max]="31"
        [showButtons]="true"
        [useGrouping]="false"
        inputStyleClass="w-full"
        styleClass="w-full">
      </p-inputNumber>
    </div>

    </ng-container>
    <!-- ================= FIM DA ETAPA 2 ================= -->

    <!-- ================= ETAPA 3 — desconto e comissão ================= -->
    <ng-container *ngIf="etapaNovoContrato === 3">

    <!-- ==================================================================
         DESCONTO E COMISSÃO — o que o cupom realmente decide.

         Fica no FIM do formulário e como seção própria porque o cupom não é
         mais um campo do contrato: ele define dois percentuais DISTINTOS
         (`porcentagemDesconto` do cliente e `porcentagemComissao` do contador)
         que só produzem efeito muito depois, na assinatura do plano.

         ⚠️ INVARIANTE dos textos — cada frase abaixo espelha uma regra do
         backend; se elas mudarem, o texto mente:
          - o desconto só vale com o contrato ATIVO e sobre o valor do PLANO
            (ContratoContadorService.buscarPercentualDescontoVigente);
          - a comissão usa o OUTRO percentual, sobre o valor já com desconto,
            dividida nos meses do plano (ComissaoService.gerarComissoesParaInscricao).
         Em especial: o desconto NÃO incide sobre o "Valor mensal" acima (os
         honorários do contador) — a frase existe justamente porque os dois
         campos convivem no mesmo modal. -->
    <div class="field col-12">
      <div class="contrato-dialog-section">
        <div class="contrato-dialog-section-label">
          <i class="pi pi-percentage"></i>
          {{ 'contador.dashboard.novo_contrato.secao_desconto_comissao' | translate }}
        </div>
        <p class="contrato-dialog-section-intro">
          {{ 'contador.dashboard.novo_contrato.cupom_explica_intro' | translate }}
        </p>
        <!-- Sem cupom escolhido ainda não há percentual: o texto entra genérico e
             ganha os números assim que o dropdown abaixo for preenchido. -->
        <ul class="contrato-dialog-section-lista">
          <li>{{ chaveTextoDescontoCupom | translate: { desconto: percentualDescontoCupom } }}</li>
          <li>{{ chaveTextoComissaoCupom | translate: { comissao: percentualComissaoCupom } }}</li>
        </ul>
        <p class="contrato-dialog-section-nota">
          {{ 'contador.dashboard.novo_contrato.cupom_explica_sem_aceite' | translate }}
        </p>
      </div>
    </div>

    <!-- Cupom: fonte dos dois percentuais explicados logo acima. Sem tooltip e sem
         hint — a seção acima já diz (melhor) o que eles diziam. Largura inteira:
         o label traz os dois percentuais mais o nome do cupom e truncava em meia
         coluna, e o campo fecha a etapa sozinho na linha. -->
    <div class="field col-12">
      <label>
        {{ 'contador.dashboard.novo_contrato.cupom' | translate }} <span class="required">*</span>
      </label>
      <p-dropdown
        [options]="cuponsDisponiveis"
        optionLabel="label" optionValue="value"
        [(ngModel)]="novoContrato.cupomId"
        [placeholder]="'contador.dashboard.novo_contrato.cupom_placeholder' | translate"
        [emptyMessage]="'contador.dashboard.novo_contrato.sem_cupons' | translate"
        appendTo="body" styleClass="w-full">
      </p-dropdown>
    </div>

    </ng-container>
    <!-- ================= FIM DA ETAPA 3 ================= -->

    <!-- Erro e pendências ficam FORA das etapas de propósito: o erro do submit pode ser
         causado por dados da etapa 1 (e aí o componente devolve o contador para lá, com a
         mensagem ainda na tela), e o aviso de pendências acompanha a etapa aberta. -->

    <!-- Erro da ultima tentativa, FIXO no modal. O toast nasce no canto superior direito,
         longe do botao, e some em 3s: quem esta olhando o rodape nao ve e conclui que o
         clique nao fez nada. Aqui o texto fica ate a proxima tentativa. -->
    <div class="field col-12" *ngIf="erroNovoContrato">
      <div class="p-3 border-round novo-contrato-erro flex align-items-start gap-2">
        <i class="pi pi-times-circle mt-1"></i>
        <span>{{ erroNovoContrato }}</span>
      </div>
    </div>

    <!-- O que ainda falta preencher NESTA etapa. Cobrar campos da outra etapa mandaria o
         contador procurar na tela um campo que não está nela. -->
    <div class="field col-12" *ngIf="camposFaltantesEtapaAtual.length > 0">
      <div class="p-3 border-round novo-contrato-faltantes flex align-items-start gap-2">
        <i class="pi pi-info-circle mt-1"></i>
        <span>
          {{ (etapaNovoContrato === 3
                ? 'contador.dashboard.novo_contrato.faltam_campos'
                : 'contador.dashboard.novo_contrato.faltam_campos_etapa') | translate }}
          <strong>{{ camposFaltantesEtapaAtual.join(', ') }}</strong>
        </span>
      </div>
    </div>
    </div>
  </div>

  <!-- Rodapé por etapa. Os 3 botões seguem à DIREITA: `_dialog-wave.scss` fixa
       `justify-content: flex-end` no `.p-dialog-footer`, e mover o "Voltar" para a esquerda
       exigiria uma regra sobre `.p-dialog` (armadilha do `::ng-deep` já registrada). -->
  <ng-template pTemplate="footer">
    <button pButton type="button"
      [label]="'contador.dashboard.novo_contrato.cancelar' | translate"
      class="p-button-secondary"
      (click)="fecharNovoContrato()"
      [disabled]="salvandoContrato">
    </button>
    <!-- Etapas 2 e 3: voltar para revisar/corrigir. Nada se perde — o formulário é um
         objeto só, os campos das etapas anteriores continuam preenchidos. -->
    <button pButton type="button"
      *ngIf="etapaNovoContrato > 1"
      [label]="'contador.dashboard.novo_contrato.voltar' | translate"
      icon="pi pi-arrow-left"
      class="p-button-secondary"
      (click)="voltarEtapa()"
      [disabled]="salvandoContrato">
    </button>
    <!-- Etapas 1 e 2: avança. Saindo da etapa 1 com uma checagem de email em voo o botão
         fica em loading e o avanço é decidido quando a resposta chega (pode auto-marcar
         "criar cadastro" ou bloquear). -->
    <button pButton type="button"
      *ngIf="etapaNovoContrato < 3"
      [label]="'contador.dashboard.novo_contrato.continuar' | translate"
      icon="pi pi-arrow-right"
      iconPos="right"
      class="btn-primary"
      (click)="avancarEtapa()"
      [disabled]="!etapaAtualValida"
      [loading]="aguardandoChecagemParaAvancar">
    </button>
    <button pButton type="button"
      *ngIf="etapaNovoContrato === 3"
      [label]="'contador.dashboard.novo_contrato.salvar' | translate"
      icon="pi pi-check"
      class="btn-primary"
      (click)="salvarContrato()"
      [disabled]="!novoContratoValido || salvandoContrato"
      [loading]="salvandoContrato">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: cliente sem conta (convite enviado)                          -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="dialogConviteVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '30rem' }"
  [breakpoints]="{ '640px': '95vw' }">

  <!-- Header com wave (variante success: confirmacao positiva de convite enviado) -->
  <div class="dialog-wave-header dialog-wave-header--success">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-send" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador.dashboard.novo_contrato.convite_titulo' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p class="m-0 line-height-3">{{ conviteMensagem }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button"
      [label]="'contador.dashboard.novo_contrato.convite_ok' | translate"
      icon="pi pi-check"
      class="btn-primary"
      (click)="dialogConviteVisivel = false">
    </button>
  </ng-template>
</p-dialog>

<p-toast />
